import { render, staticRenderFns } from "./MonitoringStatusSJDetail.vue?vue&type=template&id=1c5190a7&scoped=true&"
import script from "./MonitoringStatusSJDetail.vue?vue&type=script&lang=js&"
export * from "./MonitoringStatusSJDetail.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringStatusSJDetail.vue?vue&type=style&index=0&id=1c5190a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5190a7",
  null
  
)

export default component.exports